const NutritionalGoalsAction = {
  USE_RECOMMENDED_GOALS: 'USE_RECOMMENDED_GOALS',
  SET_MANUAL_GOALS: 'SET_MANUAL_GOALS',
  KEEP_PREVIOUS_GOALS: 'KEEP_PREVIOUS_GOALS',
};

export {
  NutritionalGoalsAction,
};
